module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-king.39c32379.svg";